// Identitas per-perangkat (per-browser), bukan per-user.
//
// Dipakai scan lock stock opname: 1 akun stocker sering dipakai di 2 HP pada
// lokasi yang sama, dan submit stock opname menyimpan snapshot penuh — HP yang
// submit terakhir menimpa seluruh hasil scan HP lain. Backend perlu membedakan
// dua perangkat pada akun yang sama, jadi user id tidak cukup.
//
// Disimpan di localStorage supaya bertahan lewat reload. Kalau localStorage
// dibersihkan, perangkat dapat id baru dan kontribusinya dihitung sebagai
// device terpisah — tidak ada data yang hilang, karena draft log (append-only)
// tidak pernah menghapus baris device mana pun.

const KEY = 'nfDeviceId';

export function getDeviceId() {
  let id = null;

  try {
    id = localStorage.getItem(KEY);
  } catch (e) {
    // Private mode / storage diblokir: kirim null, backend memperlakukannya
    // sebagai request tanpa device id (lolos, tapi tidak mengklaim lock).
    return null;
  }

  if (!id) {
    // crypto.randomUUID hanya ada di secure context browser baru — fallback
    // random + timestamp sudah cukup, ini bukan token keamanan.
    id = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `dev-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

    try {
      localStorage.setItem(KEY, id);
    } catch (e) {
      return null;
    }
  }

  return id;
}
